module.exports = "https://cdn01.riselinkedu.com/assets/images/recording_active.3756963.png";